export const getCookieDomain = () => {
  if (process.env.REACT_APP_ENVIRONMENT === 'production') {
    return '.hailtrace.com';
  }
  if (process.env.REACT_APP_ENVIRONMENT === 'staging') {
    return '.hailstalker.com';
  }
  return 'localhost';
};
